import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import Prospecting from './Prospecting';

function action({ store, params }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }
  const type = params && params.type === 'workers' ? 'worker' : 'client';
  return {
    title: `${type === 'worker' ? 'Potential Workers' : 'Potential Clients'} | Admin`,
    component: (
      <AdminLayout>
        <Prospecting type={type} />
      </AdminLayout>
    ),
  };
}

export default action;
